import {action, observable} from "mobx";
import {ICountryDto} from "../models/country";
import {NoticeTypeEnum} from "../models/notice";
import SimpleStore from "./base/simple-store";
import RootStore from "./root-store";

export default class CountryStore extends SimpleStore {

    @observable
    public countries: ICountryDto[];

    @observable
    public selectedCountry: ICountryDto;

    constructor(rootStore: RootStore) {
        super(rootStore);
    }

    public async getCountries() {
        try {
            this.startFetching();
            const result = await this.rootStore.countryApi.getCountries();
            this.setCountries(result.data);
        } catch (e) {
            this.notify(NoticeTypeEnum.Failure, e);
        } finally {
            this.finishFetching();
        }
    }

    public async selectCountry(countryId: number) {
        this.setSelectedCountry(countryId);
        const shippingStore = this.rootStore.shippingStore;
        shippingStore.resetMethodsList();
        await shippingStore.searchMethods();
    }

    public initCountriesList(): any {
        const allCountries = [];
        const rootStore = this.rootStore;

        allCountries.push({
            id: "",
            name: `-- ${rootStore.translationStore.translate("checkout.choose-country", "Choose a country")} --`
        });

        if (this.countries) {
            for (const country of this.countries) {
                allCountries.push(country);
            }
        }

        return allCountries;
    }

    @action
    public resetSelectedCountry() {
        this.selectedCountry = null;
    }

    @action
    private setSelectedCountry(countryId: number) {
        this.selectedCountry = this.countries.find(x => x.id === countryId);
    }

    @action
    private setCountries(countries: ICountryDto[]) {
        this.countries = countries;
    }
}



// WEBPACK FOOTER //
// ./src/stores/country-store.ts